import { createInMemoryAtom } from '@exodus/atoms'

const createAllAnnouncementsAtom = () => createInMemoryAtom({ defaultValue: [] })

export default createAllAnnouncementsAtom
